<template>
    <div class="contact-us-page">
      <!-- 顶部背景图区域 -->
      <div class="header-banner">
        <img src="@/../static/iamges/contactUs.png" alt="联系我们" class="banner-image">
        <div class="banner-overlay">
          <div class="banner-text">
            <div class="welcome-text">任何问题, 欢迎在此留言</div>
            <p class="service-text">严经理：18921158967</p>
          </div>
        </div>
      </div>
  
      <!-- 表单区域 -->
      <div class="form-container">
        <!-- 加载失败提示 -->
        <div v-if="loadError && formConfig.tabs.length === 0" class="error-tip">
          <i class="el-icon-warning"></i>
          <p class="error-title">加载失败</p>
          <p class="error-message">{{ errorMessage || '获取功能列表失败，请稍后重试' }}</p>
          <el-button type="primary" @click="retryLoad" size="small">重新加载</el-button>
        </div>
        <!-- 表单内容 -->
        <el-tabs v-else v-model="activeTab" @tab-click="handleTabClick" v-loading="loading">
          <el-tab-pane
            v-for="(tab, index) in formConfig.tabs"
            :key="index"
            :label="tab.label"
            :name="tab.name"
          >
            <!-- 如果 fields 还未加载，显示加载提示 -->
            <div v-if="!tab.fields || tab.fields.length === 0" class="loading-tip">
              <i class="el-icon-loading"></i>
              <span>正在加载表单...</span>
            </div>
            <!-- 表单内容 -->
            <el-form
              v-else
              :ref="`form${index}`"
              :model="formData[tab.name]"
              :rules="formRules[tab.name]"
              label-width="130px"
              class="contact-form"
            >
              <!-- 动态渲染表单字段 -->
              <template v-for="(field, fieldIndex) in tab.fields">
                <!-- 单行输入框 -->
                <el-form-item
                  v-if="field.type === 'input'"
                  :key="`${tab.name}_${fieldIndex}_input`"
                  :label="field.label"
                  :prop="field.prop"
                >
                  <el-input
                    v-model="formData[tab.name][field.prop]"
                    :placeholder="field.placeholder"
                    :maxlength="field.maxlength"
                  ></el-input>
                </el-form-item>
  
                <!-- 多行文本域 -->
                <el-form-item
                  v-else-if="field.type === 'textarea'"
                  :key="`${tab.name}_${fieldIndex}_textarea`"
                  :label="field.label"
                  :prop="field.prop"
                >
                  <el-input
                    v-model="formData[tab.name][field.prop]"
                    type="textarea"
                    :rows="field.rows || 4"
                    :placeholder="field.placeholder"
                    :maxlength="field.maxlength"
                  ></el-input>
                </el-form-item>
  
                <!-- 验证码 -->
                <el-form-item
                  v-else-if="field.type === 'captcha'"
                  :key="`${tab.name}_${fieldIndex}_captcha`"
                  :label="field.label"
                  :prop="field.prop"
                >
                  <div class="captcha-container">
                    <el-input
                      v-model="formData[tab.name][field.prop]"
                      :placeholder="field.placeholder"
                      class="captcha-input"
                      :maxlength="field.maxlength"
                    ></el-input>
                    <div class="captcha-image" @click="refreshCaptcha(tab.name)">
                      <canvas :ref="`captchaCanvas_${tab.name}`" :width="field.canvasWidth || 120" :height="field.canvasHeight || 40"></canvas>
                      <i class="el-icon-refresh captcha-refresh"></i>
                    </div>
                  </div>
                </el-form-item>
              </template>
  
              <!-- 提交按钮 -->
                <el-button
                  type="primary"
                  @click="submitForm(tab.name, index)"
                  :loading="submitting"
                  class="submit-btn"
                >
                  提交
                </el-button>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
</template>

<script>
import {request2} from '@/utils/utils'

    export default {
    name: "contactUs",
    data() {
      return {
        activeTab: '',
        submitting: false,
        loading: false,
        loadError: false,
        errorMessage: '',
        captchaCode: {},
        tempId: '', // 临时用户ID
        // JSON 动态表单配置
        formConfig: {
          tabs: []
        },
        // 缓存已加载的 fields，避免重复请求
        fieldsCache: {},
        // 表单数据（动态初始化）
        formData: {},
        // 表单验证规则
        formRules: {}
      }
    },
    async mounted() {
      // 初始化 tempId
      this.initTempId();
      // 先获取功能列表
      await this.fetchFunctionList();
    },
    methods: {
      // 初始化临时用户ID
      initTempId() {
        this.tempId = localStorage.getItem('tempId') || '';
        if (!this.tempId) {
          // 生成UUID v4
          this.tempId = this.uuidv4();
          localStorage.setItem('tempId', this.tempId);
        }
      },
      
      // 生成UUID v4
      uuidv4() {
        if (window.crypto && window.crypto.getRandomValues) {
          const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
          return template.replace(/[xy]/g, (c) => {
            const r = window.crypto.getRandomValues(new Uint8Array(1))[0] & 15;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          });
        }
        // 兼容不支持 crypto 的环境
        return (
          Date.now().toString(16) +
          '-' +
          Math.random().toString(16).substr(2, 12)
        );
      },
      
      // 获取功能列表（作为 tabs）
      async fetchFunctionList() {
        try {
          this.loading = true;
          this.loadError = false;
          this.errorMessage = '';
          
          const response = await request2('get', '/chat/functions', {});
          
          if (response && Array.isArray(response)) {
            // 将返回的数据转换为 tabs 格式
            this.formConfig.tabs = response.map(item => ({
              name: item.code,
              label: item.name,
              icon: item.icon || '',
              fields: [] // 初始为空，选中后再加载
            }));
            
            // 设置默认选中的第一个 tab
            if (this.formConfig.tabs.length > 0) {
              this.activeTab = this.formConfig.tabs[0].name;
              // 加载第一个 tab 的 fields
              await this.fetchTemplate(this.activeTab);
            }
          } else {
            this.loadError = true;
            this.errorMessage = '获取功能列表失败';
            this.$message.error('获取功能列表失败');
          }
        } catch (error) {
          console.error('获取功能列表失败:', error);
          this.loadError = true;
          this.errorMessage = error?.message || '网络请求失败，请检查网络连接';
          this.$message.error('获取功能列表失败，请稍后重试');
        } finally {
          this.loading = false;
        }
      },
      
      // 重新加载
      retryLoad() {
        this.fetchFunctionList();
      },
      
      // 获取回复模板（作为 fields）
      async fetchTemplate(code) {
        // 如果已缓存，直接使用
        if (this.fieldsCache[code]) {
          const tab = this.formConfig.tabs.find(t => t.name === code);
          if (tab) {
            tab.fields = this.fieldsCache[code];
            this.initFormRulesForTab(code);
            this.$nextTick(() => {
              this.generateCaptcha(code);
            });
          }
          return;
        }
        
        try {
          const response = await request2('get', '/chat/template', { code });
          
          if (response) {
            // 解析模板字符串为 JSON
            let fields = [];
            try {
              const templateStr = response;
              // 如果返回的是字符串，尝试解析为 JSON
              if (typeof templateStr === 'string') {
                fields = JSON.parse(templateStr);
              } else {
                fields = templateStr;
              }
              
              // 确保 fields 是数组
              if (!Array.isArray(fields)) {
                fields = [];
              }
              
              // 更新对应 tab 的 fields
              const tab = this.formConfig.tabs.find(t => t.name === code);
              if (tab) {
                tab.fields = fields;
                // 缓存 fields
                this.fieldsCache[code] = fields;
                
                // 初始化该 tab 的表单数据
                this.initFormDataForTab(code, fields);
                
                // 初始化验证规则
                this.initFormRulesForTab(code);
                
                // 生成验证码
                this.$nextTick(() => {
                  this.generateCaptcha(code);
                });
              }
            } catch (parseError) {
              console.error('解析模板失败:', parseError);
              this.$message.error('解析表单模板失败');
            }
          } else {
            this.$message.error('获取表单模板失败');
          }
        } catch (error) {
          console.error('获取表单模板失败:', error);
          this.$message.error('获取表单模板失败，请稍后重试');
        }
      },
      
      // 初始化表单数据
      initFormDataForTab(tabName, fields) {
        if (!this.formData[tabName]) {
          this.$set(this.formData, tabName, {});
        }
        if (!this.captchaCode[tabName]) {
          this.$set(this.captchaCode, tabName, '');
        }
        
        // 根据 fields 初始化表单数据
        fields.forEach(field => {
          if (!this.formData[tabName][field.prop]) {
            this.$set(this.formData[tabName], field.prop, '');
          }
        });
      },
      
      // 初始化表单验证规则（所有 tabs）
      initFormRules() {
        this.formConfig.tabs.forEach(tab => {
          this.initFormRulesForTab(tab.name);
        });
      },
      
      // 初始化单个 tab 的表单验证规则
      initFormRulesForTab(tabName) {
        const tab = this.formConfig.tabs.find(t => t.name === tabName);
        if (!tab || !tab.fields || tab.fields.length === 0) {
          return;
        }
        
        const rules = {};
        tab.fields.forEach(field => {
          if (field.required) {
            rules[field.prop] = [];
            
            // 必填验证
            rules[field.prop].push({
              required: true,
              message: `请输入${field.label}`,
              trigger: 'blur'
            });
  
            // 邮箱验证
            if (field.prop === 'email') {
              rules[field.prop].push({
                type: 'email',
                message: '请输入正确的邮箱格式',
                trigger: 'blur'
              });
            }
  
            // 电话验证
            if (field.prop === 'phone') {
              rules[field.prop].push({
                pattern: /^1[3-9]\d{9}$/,
                message: '请输入正确的手机号码',
                trigger: 'blur'
              });
            }
  
            // 验证码验证
            if (field.prop === 'captcha') {
              rules[field.prop].push({
                validator: (rule, value, callback) => {
                  if (!value) {
                    callback(new Error('请输入验证码'));
                  } else if (value.toUpperCase() !== (this.captchaCode[tabName] || '').toUpperCase()) {
                    callback(new Error('验证码错误'));
                  } else {
                    callback();
                  }
                },
                trigger: 'blur'
              });
            }
          }
        });
        this.$set(this.formRules, tabName, rules);
      },
      // 生成验证码
      generateCaptcha(tabName) {
        this.$nextTick(() => {
          const canvasRef = `captchaCanvas_${tabName}`;
          const canvas = this.$refs[canvasRef];
          if (!canvas || (Array.isArray(canvas) && !canvas[0]) || (!Array.isArray(canvas) && !canvas)) return;
          
          const canvasEl = Array.isArray(canvas) ? canvas[0] : canvas;
          const ctx = canvasEl.getContext('2d');
          const width = canvasEl.width;
          const height = canvasEl.height;
          
          // 清空画布
          ctx.clearRect(0, 0, width, height);
          
          // 生成随机验证码
          const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
          let code = '';
          for (let i = 0; i < 4; i++) {
            code += chars.charAt(Math.floor(Math.random() * chars.length));
          }
          this.captchaCode[tabName] = code;
          
          // 设置背景
          ctx.fillStyle = '#f0f0f0';
          ctx.fillRect(0, 0, width, height);
          
          // 绘制验证码
          const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD'];
          ctx.font = 'bold 24px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          
          for (let i = 0; i < code.length; i++) {
            const x = (width / 4) * i + (width / 8);
            const y = height / 2;
            const color = colors[Math.floor(Math.random() * colors.length)];
            ctx.fillStyle = color;
            ctx.fillText(code[i], x, y);
          }
          
          // 绘制干扰线
          for (let i = 0; i < 3; i++) {
            ctx.strokeStyle = colors[Math.floor(Math.random() * colors.length)];
            ctx.beginPath();
            ctx.moveTo(Math.random() * width, Math.random() * height);
            ctx.lineTo(Math.random() * width, Math.random() * height);
            ctx.stroke();
          }
        });
      },

      // 刷新验证码
      refreshCaptcha(tabName) {
        this.generateCaptcha(tabName);
        // 清空当前标签页的验证码输入
        if (this.formData[tabName]) {
          this.formData[tabName].captcha = '';
        }
      },

      // 标签切换
      async handleTabClick(tab) {
        this.activeTab = tab.name;
        // 如果该 tab 的 fields 还未加载，则加载
        if (!tab.fields || tab.fields.length === 0) {
          await this.fetchTemplate(tab.name);
        } else {
          // 如果已加载，直接生成验证码
          this.$nextTick(() => {
            this.generateCaptcha(tab.name);
          });
        }
      },

      // 提交表单
      async submitForm(tabName, tabIndex) {
        const formRef = `form${tabIndex}`;
        this.$refs[formRef][0].validate(async (valid) => {
          if (valid) {
            this.submitting = true;
            
            try {
              // 确保 tempId 已设置
              if (!this.tempId) {
                this.initTempId();
              }
              
              // 构造提交数据
              // form 字段需要是 JSON 字符串
              const formData = this.formData[tabName];
              const formJson = JSON.stringify(formData);
              // 构造请求参数
              const requestData = {
                tempId: this.tempId,
                functionCode: tabName, // 功能代码就是 tab 的 name
                form: formJson // 表单数据转为 JSON 字符串
              };
              
              // 调用提交接口
              const response = await request2('post', '/chat/form-result', requestData);
              
              // 处理响应（request2 成功时返回 data，失败时返回 false）
              if (response !== false) {
                this.$message.success('提交成功！我们会尽快与您联系。');
                
                // 重置表单
                this.$refs[formRef][0].resetFields();
                // 动态重置表单数据
                const tab = this.formConfig.tabs.find(t => t.name === tabName);
                if (tab && tab.fields) {
                  const resetData = {};
                  tab.fields.forEach(field => {
                    resetData[field.prop] = '';
                  });
                  this.$set(this.formData, tabName, resetData);
                }
                // 重新生成验证码
                this.generateCaptcha(tabName);
              } else {
                // request2 内部已处理错误提示
                // 这里可以添加额外的错误处理逻辑
              }
            } catch (error) {
              console.error('提交表单失败:', error);
              this.$message.error('提交失败，请稍后重试');
            } finally {
              this.submitting = false;
            }
            
          } else {
            this.$message.error('请填写完整的表单信息');
            return false;
          }
        });
      }
    },
    watch: {
      activeTab(newTab) {
        this.$nextTick(() => {
          this.generateCaptcha(newTab);
        });
      }
    }
    }
</script>

  <style scoped lang="css">
  .contact-us-page {
    min-height: 100vh;
  }
  
  /* 顶部背景图区域 */
  .header-banner {
    position: relative;
    width: 100%;
    height: 600px;
    overflow: hidden;
    z-index: 1;
  }
  
  .banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
  }
  
  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .banner-text {
    text-align: center;
    color: white;
  }
  
  .welcome-text {
    font-size: 60px;
    font-weight: bold;
    margin-bottom: 20px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  }
  
  .service-text {
    font-size: 24px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  }
  
  /* 表单容器 */
  .form-container {
    position: relative;
    margin: -120px auto 40px;
    padding: 0 20px;
    width: 70%;
    min-height: 400px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    z-index: 2;
  }
  
  .contact-form {
    padding: 30px;
  }
  
  .loading-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: #909399;
    font-size: 14px;
    min-height: 300px;
  }
  
  .loading-tip i {
    margin-right: 8px;
    font-size: 16px;
  }
  
  /* 错误提示 */
  .error-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
    min-height: 400px;
    text-align: center;
  }
  
  .error-tip i {
    font-size: 64px;
    color: #f56c6c;
    margin-bottom: 20px;
  }
  
  .error-title {
    font-size: 20px;
    font-weight: bold;
    color: #303133;
    margin: 0 0 10px 0;
  }
  
  .error-message {
    font-size: 14px;
    color: #909399;
    margin: 0 0 30px 0;
    line-height: 1.5;
  }
  
  .error-tip .el-button {
    margin-top: 10px;
  }
  
  /* 验证码容器 */
  .captcha-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .captcha-input {
    flex: 1;
    max-width: 200px;
  }
  
  .captcha-image {
    position: relative;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f7fa;
  }
  
  .captcha-image:hover {
    border-color: #7b9d38;
  }
  
  .captcha-refresh {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    color: #7b9d38;
    font-size: 18px;
    cursor: pointer;
    z-index: 1;
  }
  
  .captcha-refresh:hover {
    color: #5a7a2a;
  }
  
  /* 提交按钮 */
  .submit-btn {
    width: 120px;
    background-color: #7b9d38;
    border-color: #7b9d38;
  }
  
  .submit-btn:hover {
    background-color: #5a7a2a;
    border-color: #5a7a2a;
  }
  
  /* 标签页样式 */
  ::v-deep .el-tabs__header {
    margin: 0;
    padding: 20px 20px 0;
  }
  
  ::v-deep .el-tabs__item {
    font-size: 16px;
    padding: 0 30px;
    height: 50px;
    line-height: 50px;
  }
  
  ::v-deep .el-tabs__item.is-active {
    color: #7b9d38;
    font-weight: bold;
  }
  
  ::v-deep .el-tabs__active-bar {
    background-color: #7b9d38;
  }
  
  ::v-deep .el-tabs__item:hover {
    color: #7b9d38;
  }
  
  /* 响应式设计 */
  @media only screen and (max-width: 768px) {
    .header-banner {
      height: 300px;
    }
  
    .welcome-text {
      font-size: 24px;
    }
  
    .service-text {
      font-size: 18px;
    }
  
    .form-container {
      width: 100%;
      margin: -100px auto 20px;
      min-height: 300px;
      padding: 0;
    }
    
    .error-tip {
      min-height: 300px;
      padding: 40px 20px;
    }
    
    .error-tip i {
      font-size: 48px;
    }
    
    .error-title {
      font-size: 18px;
    }
    
    .error-message {
      font-size: 12px;
    }
  
    .contact-form {
      padding: 20px 10px;
    }
  
    ::v-deep .el-form-item__label {
      width: 120px !important;
    }
  
    .captcha-container {
      flex-direction: column;
      align-items: flex-start;
    }
  
    .captcha-input {
      max-width: 100%;
      width: 100%;
    }
  
    .submit-btn {
      width: 100%;
    }
  }
</style>
  